import { useAuthStore } from "@src/store"
import { Navigate, useLocation } from "react-router-dom"

const ProtectedSuperAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const isAdmin = useAuthStore((state) => state.isAdmin())
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/401" state={{ from: location }} replace />
  }

  if (!isAdmin) {
    return <Navigate to="/403" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default ProtectedSuperAdmin
